import React, {useState,useEffect} from "react";
import {HiPlus} from "react-icons/hi";
import Todo from "./components/Todo"

function App() {

  // states
  const [todos, setTodos] = useState(JSON.parse(localStorage.getItem('todos')) || []);
  const [inputValue, setInputValue] = useState('');

  // Local storage
  useEffect(() => {
    localStorage.setItem('todos', JSON.stringify(todos));
  }, [todos]);

  // Add todos
  const addTodo = (value) => {
    if(value == ''){
      alert('You cant add empty value')
    }else{
      const newTodos = [...todos, value];
      setTodos(newTodos);
      setInputValue('');
    } 
  }

  // Delete todos
  const deleteTodo = (index) =>{
    const deletedTodos = todos.filter((_, i) => i !==index)
    setTodos(deletedTodos);
  }

  // Clear todos
  const clearTodos = () => {
    localStorage.removeItem('todos')
    setTodos([])
  }


  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-500 to-blue-300 flex justify-center items-center px-5 py-5">
      <div className="bg-background-color w-[500px] py-5 px-7 rounded-xl ">
        <h1 className="text-center text-2xl font-semibold mb-4">Todo list</h1>
        <form onSubmit={(e) => {
          e.preventDefault()
          addTodo(inputValue)
          }}>
          <div className="w-full flex items-center border-[2px] border-blue-500 rounded-lg overflow-hidden h-10 bg-blue-500">
            <input onChange={e => setInputValue(e.target.value)}
            value={inputValue} type="text" className="grow h-full outline-0 p-4" placeholder="Add a task here..." />
            <button type="submit">
              <HiPlus className="h-5 w-10 text-white cursor-pointer" />
            </button>
          </div>
        </form>
        <div className="border-[1px] border-blue-300 my-6"/>
        <div className="overflow-y-auto max-h-96 style-6">
          {todos.map((todo,index) =>(
              <Todo key={index} index={index} todo={todo} deleteTodo={deleteTodo}/>
            ))}
        </div>
        <div>
          {todos.length >= 2 ?
            <button onClick={() => clearTodos() } className="bg-blue-500 mt-6 w-full text-white py-1 transition-transform duration-300 ease-in-out transform hover:scale-105">Clear All</button>
            :null
          }
        </div>
      </div>
    </div>
  );
}

export default App;
